import type {Mapper} from 'framework';
import type {CatalogExercise, CatalogExerciseMuscle} from '../../domain/catalog-exercise';
import type {CatalogExerciseDto} from '../dto/workout.dto';

const mapMuscle = (muscle: CatalogExerciseDto['muscles'][number]): CatalogExerciseMuscle => ({
  muscleId: muscle.muscleId,
  role: muscle.role,
  slug: muscle.slug,
  name: muscle.name,
});

export class CatalogExerciseDtoToCatalogExerciseMapper implements Mapper<
  CatalogExerciseDto,
  CatalogExercise
> {
  transform(dto: CatalogExerciseDto): CatalogExercise {
    return {
      id: dto.id,
      name: dto.name,
      description: dto.description,
      equipment: dto.equipment,
      isCustom: dto.isCustom,
      muscles: dto.muscles.map(mapMuscle),
    };
  }
}
